import { getUserDefault } from "~/common/defaults/user.default";
import type { AccessTokenDto } from "~/common/interfaces/dto/auth/access-token.dto";
import type { LoginDto } from "~/common/interfaces/dto/auth/login.dto";
import type { RegisterDto } from "~/common/interfaces/dto/auth/register.dto";
import type { User } from "~/common/interfaces/entities/user.interface";
import { useUsersStore } from "~/stores/users";

export const useAuthStore = defineStore("auth", () => {
	const usersStore = useUsersStore();
	const accessToken = useCookie("accessToken");

	const register = (dto: RegisterDto): Promise<User> => {
		return useNuxtApp().$apiFetch<User>("/auth/register", {
			body: dto,
			method: "POST"
		});
	};
	const login = async (dto: LoginDto): Promise<AccessTokenDto> => {
		const res = await useNuxtApp().$apiFetch<AccessTokenDto>("/auth/login", {
			body: dto,
			method: "POST"
		});

		accessToken.value = res.accessToken;

		return res;
	};
	const signOut = () => {
		accessToken.value = null;
		usersStore.me = getUserDefault();
	};

	return { register, login, signOut };
});
